import React from 'react'

function CirclePreloader(props) {
    const mystyle={
        display:'block',marginLeft:'auto',marginRight:'auto',marginTop:50,
    }
    return (
        <div className="preloader-wrapper big active center" style={mystyle}>
        <div className="spinner-layer spinner-blue-only">
          <div className="circle-clipper left">
            <div className="circle"></div>
          </div><div className="gap-patch">
            <div className="circle"></div>
          </div><div className="circle-clipper right">
            <div className="circle"></div>
          </div>
        </div>
      </div>
    )
}

export default CirclePreloader
